module.exports = __webpack_public_path__ + "img/chevron-right-gray.svg";